import { useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Plus } from "@phosphor-icons/react";
import { toast } from "sonner";

export function QuickAddBlock({ stage, disabled, onCreated }) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [currency, setCurrency] = useState("MXN");
  const [valueAmount, setValueAmount] = useState("");

  const submit = async () => {
    const t = title.trim();
    if (!t) { setOpen(false); return; }
    try {
      const payload = { stage, title: t, value_currency: currency };
      const v = parseFloat(valueAmount);
      if (!isNaN(v) && v > 0) payload.transaction_value = v;
      const { data } = await api.post("/kanban/cards/quick", payload);
      setTitle(""); setValueAmount(""); setCurrency("MXN");
      setOpen(false);
      onCreated(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error al crear tarjeta");
    }
  };

  if (disabled) return null;
  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="w-full text-left text-xs text-zinc-400 hover:text-[#002FA7] hover:bg-white px-3 py-2 rounded-sm inline-flex items-center gap-1.5 transition-colors"
        data-testid={`quick-add-${stage}`}
      >
        <Plus size={12} weight="bold" /> Nueva tarjeta
      </button>
    );
  }
  return (
    <div className="bg-white border border-[#002FA7]/40 rounded-sm p-2 space-y-1.5">
      <Input
        autoFocus
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") submit(); if (e.key === "Escape") { setTitle(""); setOpen(false); } }}
        placeholder="Nombre o descripción…"
        className="h-8 text-sm"
        data-testid={`quick-add-input-${stage}`}
      />
      <div className="flex items-center gap-1">
        <select
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
          className="text-[10px] border border-zinc-300 rounded px-1.5 h-7 bg-white"
          data-testid={`quick-add-currency-${stage}`}
          title="Moneda"
        >
          <option value="MXN">MX$</option>
          <option value="USD">US$</option>
        </select>
        <Input
          type="number"
          value={valueAmount}
          onChange={(e) => setValueAmount(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
          placeholder="Valor (opcional)"
          className="h-7 text-xs flex-1 numeric"
          data-testid={`quick-add-value-${stage}`}
        />
      </div>
      <div className="flex justify-end gap-1">
        <button onClick={() => { setTitle(""); setValueAmount(""); setOpen(false); }} className="text-[11px] text-zinc-500 px-2 py-1 hover:bg-zinc-100 rounded">Cancelar</button>
        <button onClick={submit} className="text-[11px] text-white bg-[#002FA7] hover:bg-[#002277] px-2 py-1 rounded" data-testid={`quick-add-submit-${stage}`}>Agregar</button>
      </div>
    </div>
  );
}
